import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {CommandService} from '@core/services/command.service';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {Store} from '@ngrx/store';
import {Router} from '@angular/router';
import {MagicBarQuickViewService} from '@shared/components/platform-tool/platform-tool-magic-bar/services/magic-bar-quick-view.service';
import {Observable} from 'rxjs';
import {MagicBarService} from '@shared/components/platform-tool/platform-tool-magic-bar/services/magic-bar.service';

@Injectable({
  providedIn: 'root'
})
export class DiagnosticReportService {

  private diagnosticReportActionSubject: Subject<any> = new Subject<any>();

  constructor(
    private fuseSplashScreenService: FuseSplashScreenService,
    private platformQueryService: PlatformQueryService,
    private commandService: CommandService,
    private platformSidebarStore: Store<PlatformSidebarState>,
    private magicBarService: MagicBarService,
    private magicBarQuickViewService: MagicBarQuickViewService,
    private router: Router) { }



  private emitDataSourcesAction(action: any) {
    if (!this.isDiagnosticReportOpened()) {
      return;
    }
    this.diagnosticReportActionSubject.next(action);
  }

  public getDiagnosticReportActionObservable(): Observable<any> {
    return this.diagnosticReportActionSubject.asObservable();
  }

  public isDiagnosticReportOpened(): boolean {
    const homeSidebar = this.magicBarService.getMagicLinkModel().homeSideBar;
    console.log('selected magic bar:', homeSidebar);
    return this.magicBarService.selectedMagicBar().title === 'Home' && homeSidebar
      && (homeSidebar?.items.findIndex(item => item.componentName === 'DiagnosticReportContainerComponent') !== -1);
  }


  public showDiagnosticReportCellRecordMismatchedHistoryOnRightSidebarForWorkbook(workbookId: string, worksheetId: string, worksheetName: string, cellRowIndex: number, cellColumnIndex: number) {
    if (!this.isDiagnosticReportOpened()) {
      return;
    }
    const data = {
      actionType: 'ShowDiagnosticReportCellRecordMismatchedHistory',
      isUserAction: true,
      'WorkbookId': workbookId,
      'WorksheetId': worksheetId,
      'WorksheetName': worksheetName,
      'CellRowIndex': cellRowIndex,
      'CellColumnIndex': cellColumnIndex,
    };
    this.emitDataSourcesAction({
      actionType: 'ShowDiagnosticReportCellRecordMismatchedHistory',
      data: data
    });
  }


  public invalidateDiagnosticReportCellRecordMismatchedHistoryOnRightSidebar() {
    if (!this.isDiagnosticReportOpened()) {
      return;
    }
    this.emitDataSourcesAction({
      actionType: 'ShowDiagnosticReportCellRecordMismatchedHistory',
      invalidate: true
    });
  }



}
